import React from "react";
import { useHotkey } from "@react-hook/hotkey";

import { Fab, Tooltip, ThemeProvider } from "@mui/material";
import { Printer as PrintIcon } from "mdi-material-ui";

import createLapidouTheme from "lib/theme";

const theme = createLapidouTheme("light");

const COMMAND_KEY =
  typeof window !== "undefined" && window.navigator.platform === "MacIntel"
    ? "⌘"
    : "Ctrl";

export default function PrintFab({ children, disabled, ...props }) {
  const templateRef = React.useRef();

  const handleClick = React.useCallback(() => {
    const printHtml = templateRef.current.querySelector("#root").innerHTML;

    const iframe = document.createElement("iframe");
    iframe.width = 0;
    iframe.height = 0;
    document.body.appendChild(iframe);

    iframe.contentDocument.body.innerHTML = printHtml;
    iframe.focus();
    iframe.contentWindow.print();

    document.body.removeChild(iframe);
  }, []);

  useHotkey(window, ["mod", "s"], (e) => {
    e.preventDefault();
    if (disabled) return;
    handleClick();
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <template ref={templateRef}>
          <div id="root">{children}</div>
        </template>
      </ThemeProvider>

      <Tooltip title={`Imprimer (${COMMAND_KEY} + P)`}>
        <span>
          <Fab onClick={handleClick} size="small" {...props}>
            <PrintIcon />
          </Fab>
        </span>
      </Tooltip>
    </>
  );
}
